/**
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '../BaseModel';

export class Kontoinformation extends BaseModel {
    iban: string | null = null;
    name_finanzinstitut: string | null = null;
    plz_finanzinstitut: string | null = null;
    ort_finanzinstitut: string | null = null;
    vermerk: string | null = null;
    name_kontoinhaber: string | null = null;
    adresse_kontoinhaber: string | null = null;
    plz_kontoinhaber: string | null = null;
    ort_kontoinhaber: string | null = null;

}
